import { NONE } from './selection.js';

/* --------------------------------------------------------------------------
   Kunder i lojalitetsprogrammet

   Ett kvitto med kund har customerNumber och customerName. Fälten saknas
   helt när ingen kund är vald — de är aldrig null. normalize() lägger
   numret i r.customer ('' utan kund) och namnet i r.customerName.

   Kunden hör till kvittot, som butik och kassa: urvalet på kund väljer hela
   kvitton och gäller också jämförelsen och utvecklingen. NONE väljer kvitton
   utan kund.

   Samma kundnummer kan ha olika namn på olika kvitton, om namnet ändrats i
   kundregistret. Då gäller det senaste.
   -------------------------------------------------------------------------- */

/** "Anna Svensson (1042)", eller "Kund 1042" när namnet saknas. */
export function customerLabel(number, name){
  return name ? `${name} (${number})` : `Kund ${number}`;
}

export const NO_CUSTOMER_LABEL = 'Utan kund';

/** Senaste namnet per kundnummer. receipts står i tidsordning. */
export function customerNames(receipts){
  const names = new Map();
  for(const r of receipts){
    if(!r.customer) continue;
    if(r.customerName || !names.has(r.customer)) names.set(r.customer, r.customerName || names.get(r.customer) || '');
  }
  return names;
}

/**
 * Valen i kundurvalet: [{value, label, special}], sorterade på namn, med
 * "Utan kund" sist när filen har kvitton utan kund. Tom när ingen kund finns.
 */
export function customerOptions(receipts){
  const names = customerNames(receipts);
  if(!names.size) return [];
  const opts = [...names].map(([nr, name]) => ({value: nr, label: customerLabel(nr, name)}))
    .sort((a, b) => a.label.localeCompare(b.label, 'sv', {numeric: true}));
  if(receipts.some(r => !r.customer)) opts.push({value: NONE, label: NO_CUSTOMER_LABEL, special: true});
  return opts;
}

/** Kundurvalets värde för ett kvitto: kundnumret, eller NONE. */
export const customerValue = r => r.customer || NONE;

/**
 * Kunder vars namn eller kundnummer innehåller söktexten. rows har
 * {number, name}. Tom sökning ger alla.
 */
export function searchCustomers(rows, q){
  const t = String(q ?? '').trim().toLocaleLowerCase('sv');
  if(!t) return rows;
  return rows.filter(c => c.number.toLocaleLowerCase('sv').includes(t) ||
                          (c.name || '').toLocaleLowerCase('sv').includes(t));
}
